import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function maskPhone(phone: string): string {
  if (!phone || phone.length < 3) return phone
  return phone.slice(0, -3) + "***"
}

export function formatHoursAsDayHour(hours: number): string {
  const totalHours = Math.round(hours)
  const days = Math.floor(totalHours / 24)
  const remHours = totalHours % 24
  if (days === 0) return `${remHours}h`
  return remHours > 0 ? `${days}d${remHours}h` : `${days}d`
}
